/**
 * Placeholder privacy policy. This is a reasonable starting draft, not
 * reviewed legal copy — replace before it needs to hold up to scrutiny.
 */
export function Privacy() {
  return (
    <>
      <section className="page-header">
        <h1>Privacy policy</h1>
        <p className="muted">Last updated August 27, 2026.</p>
      </section>

      <article className="panel legal">
        <p>
          Big Bear Backup is a backup client for Windows 11. Your files are encrypted
          on your own machine before anything leaves it — we designed the product this
          way so that we are never in a position to read your data, and this policy
          describes what we do handle.
        </p>

        <h2>What we collect</h2>
        <p>
          Creating an account gives us your email address and a password, stored as a
          salted hash — we never see or store your password in plain text. Signing in
          also creates a session, tracked with a cookie.
        </p>
        <p>
          The desktop app reports backup metadata to your account so the dashboard can
          show it to you: job names, schedules, snapshot timestamps, byte and chunk
          counts, and pass/fail status. This metadata describes your backups; it does
          not include the contents of the files being backed up.
        </p>
        <p>
          If a backup is configured to store its encrypted data in cloud storage, that
          encrypted data is uploaded to the vault you configured. We do not
          hold the decryption key — it derives from your passphrase, which never leaves
          your machine.
        </p>

        <h2>What we don't collect</h2>
        <p>
          We don't run analytics or tracking scripts on this site, and we don't sell or
          share your information with advertisers. We don't have access to the contents
          of your backups.
        </p>

        <h2>How we use it</h2>
        <p>
          Account and backup metadata are used to operate the service: authenticating
          you, showing your fleet's status on the dashboard, sending account-related
          email (verification, password reset), and diagnosing problems you report to
          us.
        </p>

        <h2>Where it's stored</h2>
        <p>
          Account data and backup metadata are stored with our infrastructure
          providers. Encrypted backup data goes to the vault you configure —
          typically a cloud storage bucket under your own account, which we never have
          the key to read.
        </p>

        <h2>Your choices</h2>
        <p>
          You can update your account details or delete your account from the account
          settings page. Deleting your account removes your stored metadata; it does
          not delete backup data already written to vaults you control —
          that's yours to manage directly.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about this policy can be sent to{" "}
          <a href="mailto:privacy@bigbearbackup.com">privacy@bigbearbackup.com</a>.
        </p>
      </article>
    </>
  );
}
